export const content = `Below are answers to frequently asked questions related to our recent BetterHelp rebrand.

### What is the relationship between UpLift and BetterHelp?

UpLift and BetterHelp are both part of Teladoc Health. UpLift has supported insurance-covered mental health care through a platform that operates separately from the traditional BetterHelp experience. The UpLift platform is now being updated to use the BetterHelp name and branding, creating a more consistent experience across BetterHelp’s mental health services.

### What is changing?

The UpLift platform is being updated with BetterHelp branding. You may notice new colors, logos, styling, and naming throughout the platform and in communications you receive. Although the platform will look different, the way you provide or receive care will not change.

### Why is this update happening?

The goal is to create a more consistent and connected experience across BetterHelp’s mental health services. Although the platform will look different, the parts of the experience that matter most—including providers, appointments, care, billing, insurance arrangements, and compensation—will remain the same.

### Do I need to take any action?

No. You do not need to take any action because of this update. You can continue accessing the platform and providing or receiving care as usual.

### Will my login change?

No. You can continue signing in and accessing your care as usual. You do not need to create a new account or change your login information because of the rebrand.

### Will anything change about my care?

No. Clients will continue receiving care from the same providers, and providers will continue managing their schedules, appointments, and patients as usual. Appointments, care delivery, billing, and insurance arrangements will not change because of the rebrand.

### Why did I receive an email from BetterHelp instead of Uplift?

You may begin receiving BetterHelp-branded emails and notifications as part of the update. If you are unsure whether a particular communication is legitimate, contact us at [help@joinuplift.co](mailto:help@joinuplift.co) before clicking any links or providing account information.
`;
